import React from 'react';

const Redline = () =>{
    return(<svg xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" viewBox="0 0 214.414 16.35">
                                  <path fill="none" stroke="#FF5050" stroke-width="11" d="M0.506,10.873c0,0,130.826-12.089,213.108,0"></path>
                                  </svg>)
} 
export default Redline;